
import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../../components/Error/error';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import {loadingButton} from '../../../functions';
import {updateValueInItemArray} from '../../../functions';

export default class SeccionesBoletin extends Component {

    state = {
        resource: [],
        response: [],
        optionsTipoRecurso: [],
        error: [],
        clave: this.props.clave
      }


    render() {
        return (
            (this.state.response.statusCode==200)?
            (
                <div id="detailBody" className="Site-content" >
                    <div className="loader" id="loaderSection"></div> 
                    <div hidden={true} id="content-wrapper-section" className="d-flex flex-column">
                    <div id="content">
                        <div id="Body" className="body-container container-fluid">
                            <div className="">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="recursos__wrapper-table">
                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                        <thead>
                                                            <tr>
                                                                <th className="table-bordered-radius--left">CÓDIGO</th>
                                                                <th>TÍTULO</th>
                                                                <th>ORDEN</th>
                                                                {/* <th className="text-center">ACTIVO</th> */}
                                                                <th className="table-bordered-radius--right text-center">EN BOLETIN</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.resource.map((resource) => (
                                                            <tr key={resource.nSeccionCodigo}>
                                                                <td>{resource.nSeccionCodigo}</td>
                                                                <td>{resource.sTitulo}</td>
                                                                <td>{resource.bOrden} {resource.bIsAdded} </td>
                                                                <td className="recursos__table-action-option">
                                                                    {resource.bIsAdded?
                                                                        <button id={"btn_" + resource.nSeccionCodigo + "_del"} className="btn btn-default btn-primary__tool" onClick={(event) => this.deleteBoletin(resource.nSeccionCodigo)} type="button">
                                                                            <i id={"i_" + resource.nSeccionCodigo + "_del"} className="fas fa-check fa-sm"></i>
                                                                        </button>
                                                                        :
                                                                        <button id={"btn_" + resource.nSeccionCodigo + "_add"} className="btn btn-primary btn-primary__tool" onClick={(event) => this.addBoletin(resource.nSeccionCodigo)} type="button">
                                                                            <i id={"i_" + resource.nSeccionCodigo + "_add"} className="fas fa-plus fa-sm"></i>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            )
            :
            (
                <Error StatusCode={this.state.response.StatusCode} StatusMessage={this.state.response.StatusMessage}></Error>
            )
        );
    }

    deleteBoletin(key){
        loadingButton(key + "_del", "fa-plus");
        this.saveSectionBulletin(key, 1);
    }

    addBoletin(key){
        loadingButton(key + "_add", "fa-plus");
        this.saveSectionBulletin(key, 0);
    }

    saveSectionBulletin(key, type){

        const url = `${API_URL}SectionUX/`;
        const formData = JSON.stringify({nSeccionCodigo:key, bType: type, nBoletinCodigo: this.props.clave, nUsuarioCreacion:1});
        axios.put(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {          
                    if (data.data.isSucess)
                    {
                        var valueBol;
                        if (type===0) {valueBol=true} else {valueBol =false}
                        this.setState({resource:  updateValueInItemArray(this.state.resource, "nSeccionCodigo", key, "bIsAdded", valueBol)});
                        console.log(this.state.resource);
                    } 
                }
            ).catch((error)=> {
                
            }); 
    }

    componentDidMount(){
        var key = this.props.clave;
        const url = `${API_URL}SectionUX/${key}`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            this.setState({ resource: data.result, response: data, error: data.Error });
            document.getElementById('loaderSection').classList.add('loader--hide');
            document.getElementById('content-wrapper-section').removeAttribute("hidden");
        }).catch(error => {
            let loader = document.getElementById('loaderSection');
            if(loader){
                loader.classList.add('loader--hide');
            }
        });        
    }
}
